// 中文繁体
export default {
  title:{
      homeTitle:'慧悦财经企业官网',
      aboutTitle:'关于慧悦',
      servicesTitle:'我们的服务',
      joinUSTitle:'加入我们',
      concatUSTitle:'联系我们',
      newsTitle:'慧悦资讯圈',
    },
    narBar:{
      1:'关于慧悦',
      2:'我们的服务',
      3:'慧悦资讯圈',
      4:'联系我们',
      5:'加入我们',
    },
    home:{
      1:'慧悦财经',
      2:'专注于香港与内地金融市场互联互通',
      3:'致力搭建中港两地企业与投资者沟通桥梁',
      4:'我们的服务',
      5:'慧悦财经-谘询',
      6:'专业投研团队分析及推广香港企业',
      7:'资深团队全方位提供财经策略谘询',
      8:'香港最热门港股在线教育平台',
      9:'为投资者保驾护航',
      10:'学习课程',
      11:'港股交易日直播',
      12:'了解更多',
      13:'慧悦团队每日股票市场分析',
      14:'慧悦财经5分钟懂盘前独家资讯',
      15:'善用强大媒体网络',
      16:'渗透不同平台渠道',
      17:'云集精英团队',
      18:'深厚金融投研经验成员',
      19:'资深港美股操盘手',
      20:'强大技术运营团队',
      21:'关于慧悦',
      22:'今日直播',
      23:'今日资讯',
      24:'微早报',
    },
    homeItem:{
      1:'关于慧悦',
      2:'我们的服务',
      3:'慧悦资讯圈',
      4:'联系我们',
      5:'加入我们',
      6:'慧悦财经'
    },
    about:{
      1:'关于我们',
      2:'随着中港两地金融市场互联互通进一步加深，两地资本市场都迎来历史性机遇。港股市场成为内地投资者关注的焦点，内地市场对港股教育的需求殷切，慧悦财经公共关系顾问集团有限公司应运而生，并因其特有的强大媒体合作网络、自家研究团队和行业前瞻性，为香港企业得以高效便捷发布资讯，与内地投资者互动沟通。',
      3:'微讯公众号',
      4:'慧悦资讯平台',
      5:'1.慧悦财经官方网站',
      6:'2.慧悦财经微信公众号',
      7:'3.慧悦财经应用程式',
      8:'4.新浪微博-财经主持VIVIAN',
    },
    services:{
      1:'财经顾问',
      2:'慧悦财经为客户提供专业财经顾问服务，为客户度身订造宣传计划，帮助企业在市场建立品牌，提升公司商誉。团队拥有丰富经验，清晰明确了解股票市场需求，精准地将讯息传播给受众，提供精辟意见协助企业提高在国内市场的认知度。慧悦的顾问服务内容包括：',
      3:'企业形象包装',
      4:'分析性文章及新闻稿撰写',
      5:'企业活动统筹',
      6:'媒体危机处理',
      7:'投资者关系维护',
      8:'企业宣传材料设计及制作',
      9:'慧悦线上教育课程',
      10:'慧悦财经提供线上教育课程，教育投资者了解证券资本市场投资窍门，增进投资知识。与慧悦财经合作的老师皆为市场上驰名的证券分析专家，深入浅出地向中港两地投资者解释投资心法，让投资者能在短时间内掌握实用的投资技巧。课程涵盖香港证券市场主要投资工具，包括大价股、中小价股、期权、交易所买卖基金等等，满足香港不同的投资者的学习需要。',
      11:'与慧悦合作的主打老师包括：',
      12:'丰盛金融资产管理董事—黄国英',
      13:'皓丰投资商学院创办人—朱晋民',
      15:'著名香港股市分析师—沈振盈',
      16:'三星资产运用(香港)有限公司ETF销售总管—萧晓婷',
      17:'兴证国际证券客户投资组副总裁—卢骏匡',
      18:'90后上市公司执行董事，专业投资者—浑水',
      19:'独立股评人，财经专栏作家—捕风',
      20:'现任对冲基金程式交易量化分析师—蔡嘉民',
      21:'著名香港股市分析师—魏力',
      22:'阿布扎比证券香港有限公司的零售市场销售总监—陈健豪',
    },
    news:{
      1:'股市直播',
      2:'慧悦财经每日都会进行两场一小时的直播，分为广东话和普通话时段。',
      3:'邀请市场上著名股票分析专家作为嘉宾，与投资者一起分析大市走势，实时分享投资策略。慧悦财经直播的平台遍布中港两地，包揽华人地区大部分观众群，确保直播资讯能最快、最广泛地接触受众。观众亦可以在直播期间在直播平台对嘉宾提问，解答投资疑难，增加投资准确度。',
      4:'广东话直播时段：下午13:30分至14:30分；',
      5:'直播频道：Facebook、Youtube；',
      6:'普通话直播时段：下午16:30分至17:30分；',
      7:'直播频道：富途牛牛、腾讯自选股、新浪一直播、捷利交易宝；',
      8:'今日资讯',
      9:'慧悦财经的专业财经市场分析团队每天早上都会整理“今日资讯”，总结前个交易天的大市概况、重点财经新闻、环球经济动态， 让投资者可以对当前财经局势有充分的理解，更容易掌握市场脉搏，投资时能更得心应手。',
      10:'微早报',
      11:'慧悦财经5分钟懂盘前独家资讯',
      12:'IOS下载',
      13:'ANDROID下载',
    },
    concatUS:{
      1:'香港总部：',
      2: '地址: 香港上环永乐街5号永安祥大厦6楼',
      3:'电话: (+852)3618 8460',
      4:'电邮: info@intelligentjoy.com',
      5:'深圳办公室：',
      6:'地址: 深圳市南山区高新南七道风华科技大厦2楼206-209室',
      7:'电话: (+86)0755 26718880',
      8:'电邮: it@intelligentjoy.com',
    },
    joinUS:{
      1:'加入我们',
      2:'如有意加入慧悦财经团队，请把详尽个人履历及期望薪酬发送至人力资源部: info@intelligentjoy.com',
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/zh_cn.js